import React from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import { isIE } from '../utils/';

// ie7-8 下面性能太差，直接加载。
const isIe78 = isIE(7) || isIE(8);

const emptyFun = () => {};

class BaseComp extends React.PureComponent {
    static propTypes = {
        observer: PropTypes.object.isRequired,
        event: PropTypes.object.isRequired,
        loadCallback: PropTypes.func.isRequired,
        loadData: PropTypes.any,
    };

    state = {
        isLoaded: isIe78,
    };

    componentDidMount() {
        const { observer, event, loadCallback, loadData } = this.props;
        const { isLoaded } = this.state;

        if (!isLoaded) {
            this.elm = findDOMNode(this);
            observer.observe(this.elm);
            this.unBindLazyLoad = event.on('lazyload', target => {
                if (this.elm === target) {
                    this.unBindLazyLoad();
                    if (loadCallback) {
                        loadCallback(loadData);
                    }
                    observer.unobserve(this.elm);
                    this.setState({
                        isLoaded: true,
                    });
                }
            });
        } else if (loadCallback) {
            loadCallback(loadData);
        }
    }

    componentWillUnmount() {
        const { observer } = this.props;

        if (!this.state.isLoaded) {
            this.unBindLazyLoad();
            observer.unobserve(this.elm);
        }
    }
    render() {
        return null;
    }
}

export default BaseComp;
